import { createAction, props } from '@ngrx/store';
import { IProductSolution, Item } from '../models/product-solutions.model';

export const loadGetSelectedProductSolution = createAction(
  '[GetSelectedProductSolution] Load GetSelectedProductSolutions',
  props<{ request: string }>()
);

export const loadGetSelectedProductSolutionSuccess = createAction(
  '[GetSelectedProductSolution] Load GetSelectedProductSolutions Success',
  props<{ response: IProductSolution }>()
);

export const loadGetSelectedProductSolutionFailure = createAction(
  '[GetSelectedProductSolution] Load GetSelectedProductSolutions Failure',
  props<{ error: Error | any }>()
);

export const clearSelectedProductSolution = createAction('[GetSelectedProductSolution] Clear GetSelectedProductSolutions');
